import { useEffect, useRef, useState } from "react";

// Partner logos - using placeholder approach as per original website
const partners = [
  {
    name: "Eurogarant",
    description: "Qualitätssiegel für Karosserie- und Lackierbetriebe",
    logo: "https://lackzentrum-wilke.de/wp-content/uploads/2023/03/Eurogarant-Logo_2015.png"
  },
  {
    name: "K Versicherung",
    description: "Versicherungspartner",
    logo: "https://lackzentrum-wilke.de/wp-content/uploads/2023/03/K_HKS44_PC.png"
  },
  {
    name: "Stollberg",
    description: "Lackpartner",
    logo: "https://lackzentrum-wilke.de/wp-content/uploads/2023/03/Logo_Stollberg_Slogan_rund.png"
  },
  {
    name: "NORA",
    description: "Netzwerkpartner",
    logo: "https://lackzentrum-wilke.de/wp-content/uploads/2023/03/NORA_Logo.png"
  },
  {
    name: "3C",
    description: "Technologiepartner",
    logo: "https://lackzentrum-wilke.de/wp-content/uploads/2023/04/Logo_3C-1.png"
  }
];

export const Partners = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className="py-16 lg:py-24 bg-background border-t border-b border-border/50"
    >
      <div className="container mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="max-w-3xl mx-auto text-center mb-12">
          <span className="inline-block text-sm font-semibold text-primary uppercase tracking-wider mb-3">
            Partner & Zertifizierungen
          </span>
          <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold text-foreground mb-4">
            Unsere Partner & Zertifizierungen
          </h2>
          <p className="text-muted-foreground leading-relaxed">
            Diese Partner stehen für hohe Qualitätsstandards, geprüfte Prozesse und 
            zuverlässige Materialien. Gemeinsam sorgen wir für erstklassige Ergebnisse.
          </p>
        </div>

        {/* Partners Grid */}
        <div className={`flex flex-wrap justify-center items-center gap-8 lg:gap-12 ${
          isVisible ? 'opacity-100' : 'opacity-0'
        } transition-opacity duration-700`}>
          {partners.map((partner, index) => (
            <div
              key={index}
              className="flex items-center justify-center p-6 bg-card rounded-xl border border-border/50 hover:border-primary/30 transition-all duration-300 group"
              style={{ minWidth: '140px', maxWidth: '180px' }}
            >
              <img
                src={partner.logo}
                alt={partner.name}
                className="max-h-16 w-auto object-contain filter grayscale group-hover:grayscale-0 transition-all duration-300 opacity-70 group-hover:opacity-100"
              />
            </div>
          ))}
        </div>

        {/* Trust Message */}
        <div className="mt-12 text-center">
          <p className="text-sm text-muted-foreground max-w-2xl mx-auto">
            Als zertifizierter Fachbetrieb arbeiten wir nach höchsten Qualitätsstandards 
            und nutzen ausschließlich geprüfte Materialien und modernste Technologien.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Partners;
